/**
 * What an account has agreed to.
 *
 * One version for the Terms of Use and the Privacy Policy together, because they are accepted
 * together, on one switch. Bump it when either changes in a way a person should be asked about
 * again; the sign-in records which version somebody accepted, so an old acceptance stays evidence
 * of what was agreed at the time rather than being silently stretched over new text.
 *
 * A date rather than a number, so the version says when the text it names was written.
 */
export const TERMS_VERSION = '2026-09-30.2';
/** Where the two documents live, as paths on the application's own origin. */
export const TERMS_PATH = '/terms';
export const PRIVACY_PATH = '/privacy';
//# sourceMappingURL=consent.js.map